import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { Field, reduxForm, formValueSelector } from 'redux-form';
import { required } from 'redux-form-validators';
import { injectIntl } from 'react-intl';

import { DefaultButton, ReduxSelectField } from 'common/components';
import { changeLpaStatus } from 'client/payments/_redux';
import { staticStyles } from './style';

const LpaChangeStatusForm = ({
  intl,
  toggleModal,
  lpaId,
  currentStatus,
  formStatusValue,
  changeLpaStatus,
  handleSubmit,
  invalid,
  error,
  dispatch,
  submitting,
}) => {
  const statusOptions = [
    { label: intl.formatMessage({ id: 'status_pending' }), value: 'PENDING' },
    { label: intl.formatMessage({ id: 'status_completed' }), value: 'COMPLETED' },
    { label: intl.formatMessage({ id: 'status_failed' }), value: 'FAILED' },
  ];

  const submit = handleSubmit(({ status }) => changeLpaStatus({ id: lpaId, status }, dispatch));

  return (
    <form className="LpaChangeStatusForm">
      <Field
        component={ReduxSelectField}
        name="status"
        textId="justStatuses"
        options={statusOptions}
        disabled={submitting}
        validate={[required()]}
        maxMenuHeight={170}
      />

      <div className="LpaChangeStatusForm__btns">
        <DefaultButton
          type="submit"
          textId="justConfirm"
          disabled={invalid || submitting || formStatusValue === currentStatus}
          loading={submitting}
          onClick={submit}
          filled
        />
        <DefaultButton type="button" textId="justCancel" disabled={submitting} onClick={toggleModal} />
      </div>

      {error && <strong className="formError">{error}</strong>}

      <style jsx>{staticStyles}</style>
    </form>
  );
};

LpaChangeStatusForm.propTypes = {
  toggleModal: PropTypes.func.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  dispatch: PropTypes.func.isRequired,
  changeLpaStatus: PropTypes.func.isRequired,
  invalid: PropTypes.bool.isRequired,
  submitting: PropTypes.bool.isRequired,
  intl: PropTypes.object.isRequired,
  lpaId: PropTypes.number.isRequired,
  currentStatus: PropTypes.string.isRequired,
  formStatusValue: PropTypes.string.isRequired,
  error: PropTypes.string,
};

LpaChangeStatusForm.defaultProps = {
  error: '',
};

const selector = formValueSelector('lpa-change-status-form');

export default compose(
  injectIntl,
  connect(
    state => ({
      formStatusValue: selector(state, 'status'),
    }),
    {
      changeLpaStatus: data => changeLpaStatus.request(data),
    }
  ),
  reduxForm({
    form: 'lpa-change-status-form',
    onSubmitSuccess: (_result, _dispatch, { toggleModal }) => {
      toggleModal();
    },
  })
)(LpaChangeStatusForm);
export { LpaChangeStatusForm };
